module.exports = __webpack_public_path__ + "img/IOIHANlogo300x502.aa6a4d94.png";